import { ReactNode } from "react"
import { Text } from "../Typography"

interface Props {
  children?: ReactNode
}

const Content = ({ children }: Props) => <Text use="body2">{children}</Text>

Content.displayName = `Message.Content`

Content.defaultProps = {
  children: undefined,
}

export { Content }
